import { jsPDF } from 'jspdf';
import Logo from '../assets/Logo-Negro.png';

export const generateReclamoPDF = async ({ legajo, nombre, mes, secuencia, motivo, firmaBase64, fechaProtesta }) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);

    // Colores corporativos
    const primaryColor = [236, 0, 140]; // Magenta de SiBus
    const secondaryColor = [50, 50, 50]; // Gris oscuro
    const lightGray = [240, 240, 240];

    // ==================== ENCABEZADO ESTILO TABLA ====================
    const headerHeight = 20;
    const col1Width = 50;  // Ancho columna logo
    const col3Width = 50;  // Ancho columna código documento
    const col2Width = pageWidth - col1Width - col3Width; // Ancho columna título

    // Dibujar bordes de la tabla del encabezado
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    
    // Borde exterior del encabezado
    doc.rect(0, 0, pageWidth, headerHeight);
    
    // Líneas verticales separadoras
    doc.line(col1Width, 0, col1Width, headerHeight); // Separador logo
    doc.line(pageWidth - col3Width, 0, pageWidth - col3Width, headerHeight); // Separador código

    // Logo - centrado en la primera columna
    const logoImg = new Image();
    logoImg.src = Logo;
    await new Promise(resolve => { logoImg.onload = resolve; });
    const logoWidth = 30;
    const logoHeight = 14;
    const logoPosX = (col1Width - logoWidth) / 2;
    const logoPosY = (headerHeight - logoHeight) / 2;
    doc.addImage(logoImg, 'PNG', logoPosX, logoPosY, logoWidth, logoHeight);

    // Título - centrado en la segunda columna
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    const tituloX = col1Width + (col2Width / 2);
    const tituloY = headerHeight / 2 + 2;
    doc.text('RECLAMO POR DIFERENCIA DE HABERES', tituloX, tituloY, { align: 'center' });

    // Código de documento y versión - en la tercera columna
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    const col3X = pageWidth - col3Width + 5;
    let col3Y = 8;
    
    doc.text('F030', col3X, col3Y);
    col3Y += 6;
    doc.text('VERSIÓN 01', col3X, col3Y);
    col3Y += 6;
    doc.text('REVISIÓN 12/05/26', col3X, col3Y);

    // Resetear color de texto
    doc.setTextColor(0, 0, 0);
    let yPosition = headerHeight + 10;

    // Subtítulo
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Sres. SiBus Movilidad Urbana', pageWidth / 2, yPosition, { align: 'center' });
    yPosition += 10;

    // Sección: Datos del Empleado
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('DATOS DEL EMPLEADO', margin + 2, yPosition + 5.5);
    yPosition += 12;

    // Datos en formato tabla
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    
    // Legajo y Nombre en dos columnas
    doc.setFont('helvetica', 'bold');
    doc.text('LEGAJO N°:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(String(legajo), margin + 35, yPosition);
    
    yPosition += 7;
    doc.setFont('helvetica', 'bold');
    doc.text('APELLIDO Y NOMBRE:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(nombre || 'Nombre no disponible', margin + 45, yPosition);
    
    yPosition += 7;
    doc.setFont('helvetica', 'bold');
    doc.text('MES RECLAMADO:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(mes || 'N/A', margin + 40, yPosition);
    
    // Fecha del reclamo
    if (fechaProtesta) {
      yPosition += 7;
      doc.setFont('helvetica', 'bold');
      doc.text('FECHA DEL RECLAMO:', margin + 5, yPosition);
      doc.setFont('helvetica', 'normal');
      const fecha = new Date(fechaProtesta);
      const fechaFormateada = fecha.toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      doc.text(fechaFormateada, margin + 50, yPosition);
    }

    yPosition += 15;

    // Sección: Motivo del Reclamo
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('MOTIVO DEL RECLAMO', margin + 2, yPosition + 5.5);
    yPosition += 12;

    // Texto del motivo
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Solicito por medio de la presente se me abone la diferencia de haberes', margin + 5, yPosition);
    yPosition += 6;
    doc.text(`correspondiente al mes de ${mes}, motivada por:`, margin + 5, yPosition);
    yPosition += 10;

    // Recuadro para el motivo
    const motivoLines = doc.splitTextToSize(motivo || 'Motivo no especificado', contentWidth - 10);
    const motivoHeight = motivoLines.length * 6 + 10;
    
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.rect(margin + 5, yPosition - 5, contentWidth - 10, motivoHeight);
    
    doc.setFont('helvetica', 'normal');
    doc.text(motivoLines, margin + 8, yPosition);
    yPosition += motivoHeight + 15;

    // Sección: Espacio para Resolución
    if (yPosition > pageHeight - 100) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('RESOLUCIÓN ADMINISTRATIVA', margin + 2, yPosition + 5.5);
    yPosition += 15;

    // Espacio para resolución
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.rect(margin + 5, yPosition, contentWidth - 10, 35);
    
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(9);
    doc.setTextColor(150, 150, 150);
    doc.text('Espacio reservado para la resolución del reclamo', margin + 8, yPosition + 5);
    doc.setTextColor(0, 0, 0);
    yPosition += 65;

    // Firmas finales
    const firmaWidth = 70;
    const firmaSpacing = (contentWidth - (firmaWidth * 2)) / 3;
    
    // Firma del empleado (izquierda)
    const firmaEmpleadoX = margin + firmaSpacing;
    
    // Si hay firma digital, mostrarla arriba de la línea
    if (firmaBase64) {
      try {
        console.log('🖊️ Intentando cargar firma para sección final...');
        
        const firmaImg = new Image();
        firmaImg.src = `data:image/png;base64,${firmaBase64}`;
        
        await new Promise((resolve, reject) => {
          firmaImg.onload = () => {
            console.log('✅ Firma cargada correctamente');
            resolve();
          };
          firmaImg.onerror = (err) => {
            console.error('❌ Error al cargar imagen de firma:', err);
            reject(err);
          };
        });
        
        // Agregar la firma ARRIBA de la línea - más pequeña
        doc.addImage(firmaImg, 'PNG', firmaEmpleadoX + 5, yPosition - 22, 60, 18);
        
        console.log('✅ Firma agregada al PDF');
      } catch (error) {
        console.error('❌ Error procesando firma:', error);
      }
    }
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.line(firmaEmpleadoX, yPosition, firmaEmpleadoX + firmaWidth, yPosition);
    doc.text('Firma del Empleado', firmaEmpleadoX + (firmaWidth / 2), yPosition + 5, { align: 'center' });
    
    // Firma de SiBus (derecha)
    const segundaFirmaX = margin + firmaSpacing + firmaWidth + firmaSpacing;
    doc.line(segundaFirmaX, yPosition, segundaFirmaX + firmaWidth, yPosition);
    doc.text('Firma Autorizada SiBus', segundaFirmaX + (firmaWidth / 2), yPosition + 5, { align: 'center' });

    // Footer
    yPosition = pageHeight - 15;
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(margin, yPosition, pageWidth - margin, yPosition);
    
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    const fechaGeneracion = new Date().toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    doc.text(`Documento generado el ${fechaGeneracion}`, pageWidth / 2, yPosition + 5, { align: 'center' });
    doc.text(`Reclamo N° ${secuencia || 'S/N'} - Legajo ${legajo}`, pageWidth / 2, yPosition + 9, { align: 'center' });

    // Generar el PDF
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    return {
      blob: pdfBlob,
      url: pdfUrl
    };

  } catch (error) {
    console.error('Error al generar el PDF del reclamo:', error);
    throw error;
  }
};
